import * as Yup from "yup";

const loginValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Enter a valid email")
    .required("Enter a valid email."),
  password: Yup.string().required(),
});

export default loginValidationSchema;
